import { render } from "./TestUploadFirebase.vue?vue&type=template&id=10d15bb7"
import script from "./TestUploadFirebase.vue?vue&type=script&lang=js"
export * from "./TestUploadFirebase.vue?vue&type=script&lang=js"

import "./TestUploadFirebase.vue?vue&type=style&index=0&id=10d15bb7&lang=css"

import exportComponent from "/Users/vitechasia/Documents/Kantor/project_nuxt/vuess/vtadesk-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__